import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useSocialLinks } from '../hooks/useSocialLinks';
import { getSocialIcon, getPlatformColor } from '../utils/socialIcons';
import { siteConfig } from '../mockData';
import { API_URL } from '../utils/apiUrl';
import './Footer.css';



export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [settings, setSettings] = useState(null);
  
  // Use centralized social links hook
  const { socialLinks, rawData: socialLinksData } = useSocialLinks();

  // Use CMS settings for basic info, centralized links for social
  const config = settings || siteConfig;

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/cms/settings`);
        setSettings(response.data);
      } catch (error) {
        console.error('Error fetching site settings:', error);
      }
    };
    fetchSiteSettings();
  }, []);

  return (
    <footer className="golf-footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <img 
              src={config.logoUrl || "https://customer-assets.emergentagent.com/job_tee-time-13/artifacts/pxvmf042_Golf%20Nuts%20Wide%205%20transp%20WHT.png"} 
              alt={config.siteName || "Golf Nuts"} 
              className="footer-logo"
            />
            <p className="footer-tagline">{config.tagline}</p>
            <p className="footer-description">{config.description}</p>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h3 className="footer-heading">Explore</h3>
            <Link to="/episodes" className="footer-link">Episodes</Link>
            <Link to="/hosts" className="footer-link">Hosts</Link>
            <Link to="/guests" className="footer-link">Guests</Link>
          </div>

          {/* Community */}
          <div className="footer-links">
            <h3 className="footer-heading">Community</h3>
            <Link to="/membership" className="footer-link">Join Membership</Link>
            <Link to="/contact" className="footer-link">Contact Us</Link>
            <a href="#newsletter" className="footer-link">Newsletter</a>
            <Link to="/admin/login" className="footer-link">Admin Login</Link>
          </div>

          {/* Listen On - Uses centralized social links */}
          <div className="footer-links">
            <h3 className="footer-heading">Listen On</h3>
            {socialLinksData?.spotify_url && (
              <a 
                href={socialLinksData.spotify_url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="footer-link"
              >
                Spotify
              </a>
            )}
            {socialLinksData?.apple_podcasts_url && (
              <a 
                href={socialLinksData.apple_podcasts_url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="footer-link"
              >
                Apple Podcasts
              </a>
            )}
            {socialLinksData?.youtube_url && (
              <a 
                href={socialLinksData.youtube_url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="footer-link"
              >
                YouTube
              </a>
            )}
          </div>
        </div>

        {/* Social & Copyright */}
        <div className="footer-bottom">
          <div className="social-links">
            {/* Use centralized social links - show all available */}
            {socialLinks.map((link) => {
              const IconComponent = link.icon;
              if (!IconComponent) return null;
              return (
                <a 
                  key={link.platform}
                  href={link.platform === 'email' ? `mailto:${link.url}` : link.url}
                  target={link.platform !== 'email' ? '_blank' : undefined}
                  rel={link.platform !== 'email' ? 'noopener noreferrer' : undefined}
                  className="social-link"
                  aria-label={link.name}
                  title={link.name}
                >
                  <IconComponent size={24} />
                </a>
              );
            })}
          </div>
          <p className="copyright">
            © {currentYear} {config.siteName || 'Golf Nuts'}. All rights reserved.
            {' • '}
            <Link to="/admin/login" style={{ color: 'inherit', textDecoration: 'none', opacity: 0.7 }}>
              Admin
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};
